import {Injectable} from '@angular/core';
import {AssetFilter} from "./asset-filter";
import {map, Observable} from "rxjs";

import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ApiResponse, getDataOrFail} from "../common/api-utils";
import {AssetWithProperties} from "./asset.model";
import {PrepareZipData} from "./prepare-zip-data";
import {DownloadPollData} from "./download-poll-data";

@Injectable({
    providedIn: 'root'
})
export class AssetService {


    constructor(private http: HttpClient) {
    }

    getAssets(assetFilter: AssetFilter): Observable<any> {
        // console.log("asset filter", assetFilter);
       let params =  this.getParams(assetFilter);
       return this.http.get<any>(environment.apiUrl + 'assets.json?', {
          params
       });
    }
    getServerFilters(assetFilter: AssetFilter): Observable<any> {
        let params =  this.getParams(assetFilter);
        return this.http.get<any>(environment.apiUrl + 'assets/properties.json?', {
            params
        });
    }
    getAsset(uuid: string, params ?: HttpParams): Observable<AssetWithProperties> {
        return this.http.get<ApiResponse<AssetWithProperties>>(environment.apiUrl + 'asset/' + uuid + '.json',{
            params
        }).pipe(map(getDataOrFail));
    }

    downloadAsset(uuid: string, params?: HttpParams) {
        return this.http.get<any>(environment.apiUrl + 'prepareDownload/' + uuid + '.json', {
            params
        })
    }
    prepareDownloadAssets(assetIds: string[], params?: HttpParams) {
        return this.http.post<PrepareZipData>(environment.apiUrl + 'prepareZip.json', assetIds, {
            params
        })
    }
    pollDownload(id: string) {
        return this.http.get<DownloadPollData>(environment.apiUrl + 'downloadZip/' + id + '.json')
    }
    deleteAssets(assetIds: string[]): Observable<any>   {
        return this.http.post(environment.apiUrl + 'deleteAssets.json', assetIds)
    }

    getParams(assetFilter: AssetFilter, discardPage?: boolean): HttpParams {
        let params = new HttpParams();
        if (assetFilter.page && !discardPage) {
            params = params.set('page', assetFilter.page);
        }
        if (assetFilter.resultsPerPage && !discardPage) {
            params = params.set('resultsPerPage', assetFilter.resultsPerPage);
        }
        if (assetFilter.p_brand) {
            for (let brand of assetFilter.p_brand) {
                params = params.append('p_brand[]', brand);
            }
        }
        if (assetFilter.p_division) {
            for (let div of assetFilter.p_division) {
                params = params.append('p_division[]', div);
            }
        }
        if (assetFilter.p_sport) {
            for (let entry of assetFilter.p_sport) {
                params = params.append('p_sport[]', entry);
            }
        }
        if (assetFilter.p_content) {
            for (let entry of assetFilter.p_content) {
                params = params.append('p_content[]', entry);
            }
        }
        if (assetFilter.p_channel) {
            for (let entry of assetFilter.p_channel) {
                params = params.append('p_channel[]', entry);
            }
        }
        if (assetFilter.p_asset_type) {
            for (let entry of assetFilter.p_asset_type) {
                params = params.append('p_asset_type[]', entry);
            }
        }
        if (assetFilter.p_asset_category) {
            for (let entry of assetFilter.p_asset_category) {
                params = params.append('p_asset_category[]', entry);
            }
        }
        if (assetFilter.p_product_category) {
            for (let entry of assetFilter.p_product_category) {
                params = params.append('p_product_category[]', entry);
            }
        }
        if (assetFilter.p_product_type) {
            for (let entry of assetFilter.p_product_type) {
                params = params.append('p_product_type[]', entry);
            }
        }
        if (assetFilter.p_year) {
            for (let entry of assetFilter.p_year) {
                params = params.append('p_year[]', entry);
            }
        }
        if (assetFilter.p_season) {
            for (let entry of assetFilter.p_season) {
                params = params.append('p_season[]', entry);
            }
        }
        if (assetFilter.p_language) {
            for (let entry of assetFilter.p_language) {
                params = params.append('p_language[]', entry);
            }
        }
        if (assetFilter.p_continent) {
            for (let entry of assetFilter.p_continent) {
                params = params.append('p_continent[]', entry);
            }
        }
        if (assetFilter.orderBy) {
            params = params.append('orderBy', assetFilter.orderBy);
        }
        if (assetFilter.order) {
            params = params.append('order', assetFilter.order);
        }
        if (assetFilter.collectionUuid) {
            params = params.set('collectionUuid', assetFilter.collectionUuid);
        }
        if (assetFilter.collectionSharedUuid) {
            params = params.set('collectionSharedKey', assetFilter.collectionSharedUuid);
        }
        if (assetFilter.collectionPublicUuid) {
            params = params.set('collectionPublicSlug', assetFilter.collectionPublicUuid);
        }
        if(assetFilter.q) {
            params = params.set('q', assetFilter.q);
        }
        if(assetFilter.sku) {
            params = params.set('sku', assetFilter.sku);
        }
        // console.log(params);
        return params
    }
}
